import { AsyncStandupArticle } from '@/components/async-standup/async-standup-article'
import { Container } from '@/components/container'
import { Footer } from '@/components/footer'
import { Navbar } from '@/components/navbar'
import { Head } from '@inertiajs/react'

const TITLE = 'Async Standup Playbook for Eng Teams (2026)'
const DESCRIPTION =
  'Use this async standup playbook to skip a live daily standup. Roll out a cadence, handle blockers, and see why commit digests beat status bots.'

type Faq = {
  question: string
  answer: string
}

type Props = {
  headline: string
  faqs: Faq[]
}

export default function AsyncStandupShow({ headline, faqs }: Props) {
  return (
    <>
      <Head title={TITLE}>
        <meta head-key="description" name="description" content={DESCRIPTION} />
      </Head>
      <div className="flex min-h-screen flex-col">
        <main className="flex-1 overflow-hidden">
          <Container>
            <Navbar />
          </Container>
          <div className="from-background via-feature-subtle/50 to-muted/20 min-h-100vh bg-gradient-to-b">
            <Container className="py-16 md:py-24">
              <AsyncStandupArticle headline={headline} faqs={faqs} />
            </Container>
          </div>
        </main>
        <Footer />
      </div>
    </>
  )
}
